var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { IconButton } from '@lendi-ui/button';
import getColour from '@lendi-ui/commons/colours';
import { Close } from '@lendi-ui/icon';
import React from 'react';
import styled from 'styled-components';
export var CloseButton = function (_a) {
    var onClose = _a.onClose;
    return React.createElement(IconButtonStyled, { icon: Close, color: getColour('interaction', 'disabled'), onClick: onClose });
};
var IconButtonStyled = styled(IconButton)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 0;\n"], ["\n  padding: 0;\n"])));
var templateObject_1;
//# sourceMappingURL=index.js.map